import React, { useState } from "react";
import "../styles/Internship.css";

const Internship = () => {
  const [activeFilter, setActiveFilter] = useState("Big brands");

  const filters = [
    "Big brands",
    "Work from home",
    "Engineering",
    "Media"
  ];

  const internships = [
    {
      id: 1,
      title: "SEO Content Writer",
      company: "ISF Analytica & Infomatica",
      location: "Mumbai",
      salary: "₹ 8,000 - 10,000 /month",
      duration: "6 Months",
      type: "Internship",
      activelyHiring: true,
      category: "Big brands"
    },
    {
      id: 2,
      title: "Content Writing",
      company: "ISF Analytica & Infomatica",
      location: "Mumbai",
      salary: "₹ 13,000 - 15,000 /month",
      duration: "6 Months",
      type: "Internship",
      activelyHiring: true,
      category: "Big brands"
    },
    {
      id: 3,
      title: "Social Media Marketing",
      company: "ISF Analytica & Infomatica",
      location: "Mumbai",
      salary: "₹ 10,000 - 15,000 /month",
      duration: "3 Months",
      type: "Internship",
      activelyHiring: true,
      category: "Media"
    },
    {
      id: 4,
      title: "Human Resources (HR)",
      company: "ISF Analytica & Infomatica",
      location: "Mumbai",
      salary: "₹ 6,500 - 8,000 /month",
      duration: "3 Months",
      type: "Internship",
      activelyHiring: true,
      category: "Big brands"
    },
    {
      id: 5,
      title: "Digital Marketing",
      company: "ISF Analytica & Infomatica",
      location: "Mumbai",
      salary: "₹ 15,000 - 20,000 /month",
      duration: "4 Months",
      type: "Internship",
      activelyHiring: true,
      category: "Work from home"
    },
    {
      id: 6,
      title: "Software Development",
      company: "ISF Analytica & Infomatica",
      location: "Mumbai",
      salary: "₹ 15,000 - 20,000 /month",
      duration: "6 Months",
      type: "Internship",
      activelyHiring: true,
      category: "Engineering"
    }
  ];

  const filteredInternships = internships.filter(internship =>
    activeFilter === "Big brands"
      ? ["ISF Analytica & Infomatica", "UpGrad", "Flipkart", "Microsoft", "Adobe", "Zomato"].includes(internship.company)
      : internship.category === activeFilter
  );

  return (
    <div className="internship-container">
      {/* Filters Section */}
      <section className="filters-section">
        <div className="filters-container">
          {filters.map((filter) => (
            <button
              key={filter}
              className={`filter-btn ${activeFilter === filter ? "active" : ""}`}
              onClick={() => setActiveFilter(filter)}
            >
              {filter}
            </button>
          ))}
        </div>
      </section>

      {/* Internships Grid */}
      <section className="internships-section">
        <div className="internships-grid">
          {filteredInternships.map((internship) => (
            <div key={internship.id} className="internship-card">
              {internship.activelyHiring && (
                <div className="actively-hiring-badge">
                  Actively hiring
                </div>
              )}

              <div className="internship-card-content">
                <h3 className="internship-card-title">{internship.title}</h3>
                <p className="internship-company">{internship.company}</p>

                <div className="internship-details1">
                  <div className="detail-item1">
                    <span className="detail-icon">Location :</span>
                    <span>{internship.location}</span>
                  </div>
                  <div className="detail-item1">
                    <span className="detail-icon">Salary :</span>
                    <span>{internship.salary}</span>
                  </div>
                  <div className="detail-item1">
                    <span className="detail-icon">Duration :</span>
                    <span>{internship.duration}</span>
                  </div>
                </div>

                <div className="internship-footer">
                  <span className="internship-type">{internship.type}</span>
                  <button className="view-details-btn">
                    View details →
                  </button>
                </div>
              </div>
            </div>
          ))}

          {filteredInternships.length === 0 && (
            <div className="empty-state">
              <h3>No internships found</h3>
              <p>Try selecting another filter to see more opportunities.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Internship;
